// validate if its email or not
// this return true if valid otherwise false

 const validateEmail = (email) => {
    let obj = null
    if (email !== '') {
        const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        let isValid = re.test(String(email).toLowerCase())
        obj = {
            isValid: isValid,
            message: isValid ? '' : 'Please enter correct email'
        }
    } else {
        obj = {
            isValid: true,
            message: ''
        }
    }
    return obj
}
export default validateEmail